import * as React from 'react';
import { SVGProps } from 'react';

const SvgUnderperform = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={32} height={32} rx={16} fill="#F7B0B0" />
    <path
      d="M11.674 20.122c1.792 0 2.89-1.05 2.89-2.607v-4.56H13.31v4.457c0 .977-.591 1.616-1.636 1.616s-1.64-.64-1.64-1.616v-4.458h-1.26v4.56c0 1.558 1.113 2.608 2.9 2.608Zm6.108-7.168H16.68l-1.846 8.755h1.099l1.85-8.755Zm.65 7.046h1.26v-2.33h1.454c1.426 0 2.398-.946 2.398-2.353v-.01c0-1.41-.972-2.353-2.398-2.353h-2.714V20Zm2.402-6.016c.903 0 1.43.484 1.43 1.329v.01c0 .844-.527 1.332-1.43 1.332h-1.143v-2.67h1.143Z"
      fill="#174174"
    />
  </svg>
);

export default SvgUnderperform;
